// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2VfPY","right":"Footer_right__3R5d3","buttons":"Footer_buttons__3Fi4m"};